module.exports = __webpack_public_path__ + "img/stock0.e5db1708.png";